// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class TradableIdRouteId {
    constructor(tradableId, routeId) {
        this.tradableId = tradableId;
        this.routeId = routeId;
    }
}
